import antdEnUS from "antd/es/locale/en_US";
import antdEsES from "antd/es/locale/es_ES";

import en from "./locales/en_US.json";
import es from "./locales/es_ES.json";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { APP_TOKENS } from "constants/AppConstant";

export const resources = {
  en: {
    translation: en,
    antd: antdEnUS,
  },
  es: {
    translation: es,
    antd: antdEsES,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: localStorage.getItem(APP_TOKENS.locale) || "es",
  lng: localStorage.getItem(APP_TOKENS.locale) || "es",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
